function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_21503_13422)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip1_21503_13422)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.9403 1.50985C17.8315 0.402965 16.0359 0.402965 14.927 1.50985L13.9224 2.51998L3.22835 13.2084L3.20562 13.2313C3.20012 13.2368 3.20012 13.2426 3.19426 13.2426C3.18289 13.2597 3.16585 13.2765 3.15466 13.2936C3.15466 13.2993 3.1488 13.2993 3.1488 13.305C3.13744 13.322 3.13193 13.3334 3.12039 13.3504C3.11489 13.3561 3.11489 13.3616 3.10921 13.3675C3.10353 13.3845 3.09784 13.3959 3.09198 13.4129C3.09198 13.4184 3.08648 13.4184 3.08648 13.4243L0.713789 20.5592C0.644186 20.7623 0.697098 20.9873 0.849975 21.1381C0.957397 21.2441 1.10228 21.3034 1.25303 21.3028C1.31464 21.3018 1.37572 21.2922 1.43467 21.2744L8.56411 18.896C8.56961 18.896 8.56961 18.896 8.57547 18.8905C8.5934 18.8852 8.61063 18.8776 8.62643 18.8676C8.63087 18.8671 8.63478 18.8651 8.63797 18.8621C8.65484 18.8508 8.67757 18.8392 8.69461 18.8279C8.71148 18.8167 8.7287 18.7996 8.74575 18.7883C8.75143 18.7824 8.75694 18.7824 8.75694 18.7769C8.76279 18.7712 8.77416 18.7657 8.77984 18.7542L20.4785 7.05549C21.5854 5.94664 21.5854 4.15101 20.4785 3.04235L18.9403 1.50985ZM8.38247 17.5621L4.43183 13.6116L14.3198 3.72363L18.2704 7.67409L8.38247 17.5621ZM3.87537 14.6617L7.32671 18.1128L2.14419 19.8383L3.87537 14.6617ZM19.6783 6.26074L19.0765 6.86816L15.1257 2.91735L15.7333 2.3101C16.3979 1.64604 17.4752 1.64604 18.1399 2.3101L19.6838 3.85396C20.3434 4.52157 20.3409 5.59632 19.6783 6.26074Z",
  fill: "#707070"
})));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_21503_13422"
}, /*#__PURE__*/React.createElement("rect", {
  width: 22,
  height: 22,
  fill: "white"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip1_21503_13422"
}, /*#__PURE__*/React.createElement("rect", {
  width: 22,
  height: 22,
  fill: "white"
})));

var SvgEdit = function SvgEdit(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/edit.25ea4daf.svg";
export { ForwardRef as ReactComponent };